import axios from 'axios'
import Cookies from 'js-cookie'
import store from "@/store";
import {getCompanyId} from "@/utils/getCompanyId";
import notifyError from "@/utils/notifyError";

const PRODUCT_API_URL = import.meta.env.VITE_API_URL_PRODUCT

const axiosRequest = async (
    url: string,
    method = 'GET',
    payload: unknown = null,
    type = 'application/json; charset=utf-8',
    shouldContainCompanyId = true
) => {
    try {

        const token = Cookies.get('neatolabsToken');

        if (!token) {
            console.log('no token')
            store.currentUser = null;
            store.status.authExpired = true;
        }


        let currentCompanyId = getCompanyId()


        //let currentCompanyId = selectedCompanyId ?? companies[0];
        const requestUrl = `${PRODUCT_API_URL}/v2${shouldContainCompanyId ? '/companies/' + currentCompanyId : ''}${url}`


        const headers = {
            'Content-Type': type,
            Authorization: `Bearer ${token}`,
        }

        const response = await axios({
            url: requestUrl,
            method,
            headers,
            data: payload || null,
        })

        return response.data
    } catch (error:any) {
        if (error.response && error.response?.status === 401 && error.response?.data?.message === "JWT is invalid.") {
            /*store.currentUser = null;
            Cookies.remove('neatolabsToken');
            store.status.authExpired = true;*/
        }
        notifyError(error)
        throw error
    }
}

export default axiosRequest
